import { render } from "./ChangePassword.vue?vue&type=template&id=6643f93b&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=6643f93b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6643f93b"

export default script